import {
    Radar,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    ResponsiveContainer,
} from "recharts";

function shortLabel(s) {
    if (s.length <= 18) return s;
    return s.split(" ").slice(0, 2).join(" ");
}

const RADAR_AXIS_TICK = { fontSize: 10, fill: "#475569" };
const RADAR_RADIUS_TICK = { fontSize: 10, fill: "#94a3b8" };
const RADAR_DOMAIN = [0, 5];

export default function ReadinessDiagnostic({
    categories = [],
    values = {},
    onChange,
    readOnly = false,
}) {
    const data = categories.map((c) => ({
        category: shortLabel(c.label),
        full: c.label,
        score: Number(values[c.key] ?? 0),
    }));

    return (
        <section className="tile rounded-sm p-6 lg:p-8" data-testid="readiness-diagnostic">
            <div className="flex items-baseline justify-between mb-2">
                <div className="overline">Customer readiness diagnostic</div>
                <span className="text-[11px] font-mono uppercase tracking-[0.18em] text-amber-700">
                    Workshop diagnostic — not a certification
                </span>
            </div>
            <h3 className="text-xl lg:text-2xl font-bold tracking-tight mb-6">
                Where is your organisation today?
            </h3>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="h-72">
                    <ResponsiveContainer width="100%" height="100%">
                        <RadarChart data={data} outerRadius="78%">
                            <PolarGrid stroke="#cbd5e1" />
                            <PolarAngleAxis
                                dataKey="category"
                                tick={RADAR_AXIS_TICK}
                            />
                            <PolarRadiusAxis
                                angle={30}
                                domain={RADAR_DOMAIN}
                                tick={RADAR_RADIUS_TICK}
                            />
                            <Radar
                                dataKey="score"
                                stroke="#0f172a"
                                fill="#0f172a"
                                fillOpacity={0.15}
                            />
                        </RadarChart>
                    </ResponsiveContainer>
                </div>

                <div className="space-y-3">
                    {categories.map((c) => {
                        const v = Number(values[c.key] ?? 0);
                        return (
                            <div
                                key={c.key}
                                className="flex items-center gap-3"
                                data-testid={`diagnostic-row-${c.key}`}
                            >
                                <div className="w-48 text-sm text-slate-700">{c.label}</div>
                                <input
                                    type="range"
                                    min={0}
                                    max={5}
                                    step={1}
                                    value={v}
                                    disabled={readOnly}
                                    onChange={(e) =>
                                        onChange &&
                                        onChange({
                                            ...values,
                                            [c.key]: Number(e.target.value),
                                        })
                                    }
                                    className="flex-1 accent-slate-900"
                                    data-testid={`diagnostic-slider-${c.key}`}
                                />
                                <span className="w-8 text-right font-mono text-sm text-slate-900">
                                    {v}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
